/** Completion follows the shift lifecycle, independently of invoice/payment state. */
export const isCompletedWorkerShift = (job: { shift?: { status?: string | null } | null }): boolean =>
  ['completed', 'complete'].includes(job.shift?.status?.toLowerCase() ?? '');
